import { render, staticRenderFns } from "./KitContract.vue?vue&type=template&id=cca2d1c4&scoped=true&"
import script from "./KitContract.vue?vue&type=script&lang=js&"
export * from "./KitContract.vue?vue&type=script&lang=js&"
import style0 from "./KitContract.vue?vue&type=style&index=0&id=cca2d1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca2d1c4",
  null
  
)

export default component.exports